(function ($) {
    // menu
    $('.menu-button').on('click', function () {
        let m = $(this);

        if(m.is('.active')){
            m.removeClass('active');
            $('.mobile-nav, body').removeClass('active');
            $('body').removeClass('body-overflow');
        } else {
            m.addClass('active');
            $('.mobile-nav, body').addClass('active');
            $('body').addClass('body-overflow');
        }

        checkMobilePosition();
    });

    $('.menu-item-has-children > a').on('click touchstart', function (e){
        e.preventDefault();

        let that = $(this),
        dropdown = that.siblings('.sub-menu');

        dropdown.slideToggle(100);
    });

    // run scripts on scroll
    $(window).on('ready resize orientationchange', function (){
        checkMobilePosition();
    });

    function setMenuHeight() {
    }

    function checkMobilePosition(){
        let mth = $('#header').offset().top - $(document).scrollTop();
        let t = $('#header').height() + mth;
        let t_px = t + 1 + 'px';

        $('.mobile-nav').css({
            'padding-top' : t_px,
        });
    }
}(jQuery));


